/**
 * 右カラム上部: グラフ描画（設定は右カラム上部パネル／種類ツールバーから開く）
 * 親が resultCache ありのときだけマウントする（空の灰色列は出さない）。
 */

import { useTranslation } from 'react-i18next';
import { useKeisukeDashboardStore } from '../../../../stores/systems/keisuke/dashboardStore';
import KeisukeDashboardChart from './KeisukeDashboardChart';
import { useKeisukeChartSettingsUi } from './keisukeChartSettingsUiContext';
import styles from './KeisukeDashboardChartPanel.module.scss';

export default function KeisukeDashboardChartPanel() {
  const { t } = useTranslation();
  const chartSettingsUi = useKeisukeChartSettingsUi();
  const isCalculating = useKeisukeDashboardStore((s) => s.isCalculating);

  return (
    <section
      className={styles.panel}
      aria-label={t('keisuke.dashboard.rightPaneLabel')}
      data-keisuke-chart-panel="ready"
    >
      {/*
        棒グラフ以外向けの入口。plot-type-toolbar があるときは CSS で隠す。
      */}
      {chartSettingsUi && !chartSettingsUi.open ? (
        <div className={styles.settingsEntryRow} data-keisuke-chart-settings-entry>
          <button
            type="button"
            className={styles.settingsEntryBtn}
            onClick={chartSettingsUi.toggle}
            aria-expanded={false}
            aria-controls="keisuke-chart-settings-panel"
            title={t('keisuke.workspace.showChartSettings')}
            aria-label={t('keisuke.workspace.showChartSettings')}
          >
            <i className="fas fa-sliders-h" aria-hidden />
            <span>{t('keisuke.workspace.chartSettingsBand')}</span>
          </button>
        </div>
      ) : null}
      <div className={styles.chartArea} data-keisuke-report-section="chart">
        <KeisukeDashboardChart isCalculating={isCalculating} />
      </div>
    </section>
  );
}
